import React, { createContext, useContext, ReactNode, useState } from 'react';

interface SlideOverDialogContextType {
  surfaceSensors: any,
  visibleSurfaceSensors: any,
  setSurfaceSensors: React.Dispatch<React.SetStateAction<any>>,
  setSurfaceSensorsVisibility: React.Dispatch<React.SetStateAction<any>>,

  elevatedSensor: any,
  visibleElevatedSensors: any,
  setElevatedSensors: React.Dispatch<React.SetStateAction<any>>,
  setElevatedSensorsVisibility: React.Dispatch<React.SetStateAction<any>>,

  activeMonitor: boolean,
  activeMonitorVisibility: boolean,
  setActiveMonitor: React.Dispatch<React.SetStateAction<boolean>>
  setActiveMonitorVisibility: React.Dispatch<React.SetStateAction<boolean>>,
  
  loadingStateForDialog: boolean
  setLoadingStateForDialog: React.Dispatch<React.SetStateAction<boolean>>

  droneSensors: any, 
  setDroneSensors:  React.Dispatch<React.SetStateAction<any>>,
  visibleDroneSensors: any, 
  setDroneSensorsVisibility: React.Dispatch<React.SetStateAction<any>>
}

const SlideOverDialogContext = createContext<SlideOverDialogContextType | undefined>(undefined)

export function SlideOverDialogProvider({ children }: { children: ReactNode }) {
  const [surfaceSensors, setSurfaceSensors] = useState([])
  const [visibleSurfaceSensors, setSurfaceSensorsVisibility] = useState([])

  const [elevatedSensor, setElevatedSensors] = useState([])
  const [visibleElevatedSensors, setElevatedSensorsVisibility] = useState([])

  const [activeMonitor, setActiveMonitor] = useState(false)
  const [activeMonitorVisibility, setActiveMonitorVisibility] = useState(false)

  const [loadingStateForDialog, setLoadingStateForDialog] = useState<boolean>(false)

  const [droneSensors, setDroneSensors] = useState([])
  const [visibleDroneSensors, setDroneSensorsVisibility] = useState([])

  return (
    <SlideOverDialogContext.Provider
      value={{
        surfaceSensors, setSurfaceSensors,
        visibleSurfaceSensors, setSurfaceSensorsVisibility,

        elevatedSensor, setElevatedSensors,
        visibleElevatedSensors, setElevatedSensorsVisibility,

        activeMonitor, setActiveMonitor,
        activeMonitorVisibility, setActiveMonitorVisibility,

        loadingStateForDialog, setLoadingStateForDialog,

        droneSensors, setDroneSensors,
        visibleDroneSensors, setDroneSensorsVisibility
      }}
    >
      {children}
    </SlideOverDialogContext.Provider>
  )
}

export function useSlideOverDialogContext() {
  const context = useContext(SlideOverDialogContext);
  if (!context) {
    throw new Error('useSlideOverDialogContext must be used within a SlideOverDialogProvider');
  }
  return context;
}
